import React from "react";
import { Modal, Button } from "@/Components/Common/Tailwind";
import { QRCodeSVG } from "qrcode.react";

interface UserQrModalProps {
    isOpen: boolean;
    toggle: () => void;
    userInfo: any;
}

const UserQrModal: React.FC<UserQrModalProps> = ({ isOpen, toggle, userInfo }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <div className="flex flex-col items-center justify-center p-6 space-y-4 bg-white rounded-lg">
                <h3 className="text-lg font-bold text-gray-900" style={{ fontFamily: "Gmarket-M" }}>내 QR 코드</h3>
                <div className="p-4 bg-white rounded-xl shadow-sm border border-gray-100">
                    <QRCodeSVG
                        value={userInfo?.phone_num || "no-data"}
                        size={200}
                        level="H"
                        includeMargin={true}
                    />
                </div>
                <div className="text-center">
                    <p className="text-lg font-bold text-gray-800" style={{ fontFamily: "Gmarket-M" }}>{userInfo?.username}</p>
                    <p className="text-sm text-gray-500">{userInfo?.phone_num?.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3")}</p>
                </div>
                <Button
                    onClick={toggle}
                    variant="secondary"
                >
                    닫기
                </Button>
            </div>
        </Modal>
    );
};

export default UserQrModal;
